import React, { Component } from 'react';
import StripeCheckout from 'react-stripe-checkout';

import {Table, TableBody, TableRow, TableRowColumn} from 'material-ui/Table';
import {Card, CardText} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import moment from 'moment';
import Config from '../conf';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

const Theme = Config.THEME;

import 'whatwg-fetch';

class Confirm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      confirmDisabled: false,
      error: false,
      payType: 'credit',
      paymentComplete: false
    };

    this.retry = this.retry.bind(this);
    this.refreshPage = this.refreshPage.bind(this);
    this.onToken = this.onToken.bind(this);
    this.confirmClicked = this.confirmClicked.bind(this);
  }

  confirmClicked() {
    this.setState({
      confirmDisabled: true
    });
    setTimeout(() => {
      this.setState({
        confirmDisabled: false
      });
    }, 3000);
  }

  onToken(token) {
    // set loading status
    this.setState({
      loading: true
    });

    const body = {
      tokenId: token.id,
      email: this.props.details.email
    };
    fetch(Config.BACKEND_API_URL + 'carpark/stripe', {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then((response) => {
      return response.json();
    }).then((data) => {
      console.log('response was: ' + JSON.stringify(data, null, 2));
      if (data.status === 200) {
        this.setState({
          paymentComplete: true
        });
      } else {
        throw Error('response status from backend was ' + data.status + ' (data = ' + JSON.stringify(data) + ')');
      }
    }).catch((err) => {
      // set error
      this.setState({
        error: true
      });
      console.log('err:', err);
    });
  };

  onPayCashConfirm(token) {
    // set loading status
    this.setState({
      loading: true
    });

    const body = {
      email: this.props.details.email
    };
    fetch(Config.BACKEND_API_URL + 'carpark/paycash', {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then((response) => {
      return response.json();
    }).then((data) => {
      console.log('response was: ' + JSON.stringify(data, null, 2));
      if (data.status === 200) {
        this.setState({
          paymentComplete: true
        });
      } else {
        throw Error('response status from backend was ' + data.status + ' (data = ' + JSON.stringify(data) + ')');
      }
    }).catch((err) => {
      // set error
      this.setState({
        error: true
      });
      console.log('err:', err);
    });
  };
  
  refreshPage() {
    location.reload();
  }

  retry() {
    this.setState({
      confirmDisabled: false,
      loading: false,
      error: false
    });
  }

  onPayChange(ev, value) {
    this.setState({ payType: value });
  }

  render() {
    const styles = {
      card: {
        padding: 30,
        paddingTop: 40,
        textAlign: 'center',
        borderRadius: 12
      },
      title: {
        textAlign: 'center',
        margin: 0,
        color: Theme.palette.primary1Color,
        marginBottom: 20
      },
      button: {
        width: 100,
        marginTop: 20,
        marginLeft: 5,
        marginRight: 5
      },
      field: {
        padding: 0,
        margin: 0,
        marginTop: -15,
        width: '100%'
      },
      fieldHintStyle: {
        textAlign: 'center'
      },
      table: {
        paddingLeft: '25%',
        paddingRight: '25%',
        paddingTop: 30,
        paddingBottom: 20
      },
      nameCol: {
        textAlign: 'center',
        fontWeight: 'bold'
      },
      valueCol: {
        textAlign: 'center'
      }
    };

    const rows = [
      { name: 'Full Name', value: this.props.details.name },
      { name: 'Mobile Number', value: this.props.details.phone },
      { name: 'Number Plate', value: this.props.details.numberPlate },
      { name: 'Wash Details', value: this.props.details.washDescription },
      { name: 'Wash Date', value: moment(this.props.details.created).format('YYYY/MM/DD') }      
    ];

    return (
      <div>
      {!this.state.error && !this.state.loading && !this.state.paymentComplete &&
        <Card style={styles.card}>
          <h2 style={styles.title}>
            Confirm Payment
          </h2>

          {this.props.details.isSmallScreen ?
            <div>
            {rows.map((row) => {
              return (
                <p key={row.name}>
                  <strong>{row.name}</strong>:
                  <br />
                  {row.value}
                </p>
              );
            })}
            </div>
          :
            <Table selectable={false} style={styles.table}>
              <TableBody displayRowCheckbox={false}>
              {rows.map((row) => {
                return (
                  <TableRow key={row.name}>
                    <TableRowColumn style={styles.nameCol}>{row.name}</TableRowColumn>
                    <TableRowColumn style={styles.valueCol}>{row.value}</TableRowColumn>
                  </TableRow>
                );
              })}
              </TableBody>
            </Table>
          }
          <div>
            <RadioButtonGroup name="pay" onChange={this.onPayChange.bind(this)} defaultSelected={this.state.payType} style={{"display": "inline-flex", 'textAlign': 'left'}}>
              <RadioButton
                value="cash"
                label="Cash"
                style={{ 'width': '150px' }}
              />
              <RadioButton
                value="credit"
                label="Credit Card"
                style={{ 'width': '150px' }}
              />
            </RadioButtonGroup>
          </div>
          <RaisedButton style={styles.button}
            label="Back" primary={true} onClick={this.props.back} />
          {this.state.payType === 'credit' && this.props.details.email &&  
            <StripeCheckout
              name={'WipeHero'}
              image="./logo_stripe.png"
              currency="AUD"
              token={this.onToken}
              allowRememberMe={false}
              stripeKey={Config.STRIPE_API_KEY}
              email={this.props.details.email}
            >

              <RaisedButton
                style={styles.button}
                label="Confirm"
                primary={true}
                onClick={this.confirmClicked}
                disabled={this.state.confirmDisabled}
              />
            </StripeCheckout>
          }
          {this.state.payType === 'cash' && this.props.details.email &&  
            <RaisedButton
              style={styles.button}
              label="Confirm"
              primary={true}
              onClick={this.onPayCashConfirm.bind(this)}
              disabled={this.state.confirmDisabled}
            />
          }  
        </Card>
      }
      {this.state.loading && !this.state.paymentComplete && !this.state.error &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Processing your payment...</h2>
          <CardText>
            <CircularProgress />
          </CardText>
        </Card>
      }
      {this.state.paymentComplete && this.state.payType ==='credit' &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Done!</h2>
          <CardText>
            <p>Your payment has been received. We hope you've enjoyed our service!</p>
            <p>
              When you require another carwash in the future, simply spend 2 minutes to make a booking on our main
              website at <a href="https://www.wipehero.com.au/">www.wipehero.com.au</a> and <strong>we'll come to
              you!</strong>
            </p>
          </CardText>
        </Card>
      }
      {this.state.paymentComplete && this.state.payType === 'cash' &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Done!</h2>
          <CardText>
            <p>Please pay our staff using cash and collect your keys.</p>
            <p>
              When you require another carwash in the future, simply spend 2 minutes to make a booking on our main
            website at <a href="https://www.wipehero.com.au/">www.wipehero.com.au</a> and <strong>we'll come to
            you!</strong>
            </p>
          </CardText>
        </Card>
      }  
      {this.state.error && !this.state.paymentComplete &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Error</h2>
          <CardText>
            <div>
              Your credit card has been declined, please try again. If this issue persists, please contact us on
              1300 791 421 or email hello@wipehero.com
            </div>
            <div>
              <RaisedButton
                style={{...styles.button,...{marginTop: 40}}}
                label="Retry"
                primary={true}
                onClick={this.retry}
              />
            </div>
          </CardText>
        </Card>
      }
      </div>
    );
  }
}

export default Confirm;



// WEBPACK FOOTER //
// ./src/app/payment/Payment.js